import type { VacationIneligibilityReason } from '../../models/vacation.types';
import { DRAFT_GRACE_MINUTES } from '../../utils/vacationRequestStatus';
import { MONTHS_TO_REQUEST } from '../../utils/vacationEligibility';
import { formatDateSafe } from '@/utils/dateUtils';

export const INELIGIBILITY_MESSAGES: Record<VacationIneligibilityReason, string> = {
    ContractType:
        'O controle de férias por este módulo está disponível apenas para colaboradores celetistas.',
    InactiveStatus:
        'Seu cadastro consta como inativo. Procure o DP para regularizar antes de solicitar férias.',
    MissingAdmissionDate:
        'Seu cadastro está sem data de admissão, que é a base do cálculo de férias. Procure o DP para completá-lo.',
};

export const PAGE_TITLE = 'Minhas férias';
export const REQUESTS_LOADING_MESSAGE = 'Verificando seus pedidos...';
export const PAGE_SUBTITLE =
    'Consulte seu saldo, agende suas férias e acompanhe o andamento das solicitações.';

export const OPEN_REQUEST_BLOCK_MESSAGE = 'Você já tem uma solicitação em aberto, acompanhe-a ao lado.';
export const OPEN_REQUEST_BLOCK_HINT = 'Você poderá enviar uma nova solicitação quando esta for reprovada ou concluída.';

export const DRAFT_REQUEST_BLOCK_MESSAGE =
    'Sua solicitação foi registrada e ainda não foi enviada ao gestor.';
export const DRAFT_REQUEST_BLOCK_HINT =
    `Você pode confirmar agora para enviar ao gestor ou excluir se quiser refazer. Se não fizer nada, a solicitação será enviada automaticamente após ${DRAFT_GRACE_MINUTES} minutos.`;

export const TOO_EARLY_BLOCK_MESSAGE =
    'Você ainda não completou tempo suficiente para solicitar férias.';
export const TOO_EARLY_BLOCK_HINT =
    `O formulário fica disponível a partir de ${MONTHS_TO_REQUEST} meses — acompanhe o progresso acima.`;

export const UNKNOWN_BALANCE_BLOCK_MESSAGE =
    'Seu saldo de férias ainda não foi calculado.';
export const UNKNOWN_BALANCE_BLOCK_HINT =
    'O DP vai conferir seu cadastro. O formulário é liberado assim que o saldo aparecer aqui.';

export const UP_TO_DATE_BLOCK_MESSAGE = 'Suas férias estão em dia.';

export function buildUpToDateBlockHint(nextEntitlementDate: string | null): string {
    if (!nextEntitlementDate) {
        return 'Aguarde o próximo período aquisitivo para solicitar de novo.';
    }
    return `Aguarde o próximo período aquisitivo: a partir de ${formatDateSafe(nextEntitlementDate)} você poderá solicitar de novo.`;
}
